export default __webpack_public_path__ + "static/page-not-found-d1bacaa27cef633a48df8da3e93910b0.svg";